import { TransfersRepository } from '@core/repositories/transfers.repository';
import { SearchCustomer, SearchReference, TransferEdit } from '@shared/interfaces/transfer';
import { Observable, of, throwError } from 'rxjs';

interface ResultTransfer {
  page: number;
  meta: {
    'total-items': number;
    'items-page': number;
    'exist-more-pages': number;
    'document-type-id': string;
    'document-type-name': string;
    'document-number': string;
    fullname: string;
    'montly-accumulated': number;
    'annual-accumulated': number;
  };
  data: Array<ResultData>;
}

interface ResultData {
  id: string;
  type: string;
  attributes: {
    amount: string;
    'cancellation-reason': string;
    'cancellation-reason-detail': string;
    commission: string;
    'document-number': string;
    'document-type-id': string;
    'document-type-name': string;
    fullname: string;
    'receiver-cellphone': number;
    'sender-cellphone': number;
    'sent-channel': string;
    'sent-correspondent': string;
    'sent-date': string;
    'sent-office': string;
    'sent-transaction-id': string;
    'status-channel': string;
    'status-correspondent': string;
    'status-date': string;
    'status-id': string;
    'status-name': string;
    'status-office': string;
    taxes: string;
  };
}

interface ResultTransferItem {
  data: {
    type: string;
    id: string;
    attributes: {
      amount: string;
      'cancellation-reason': string;
      'cancellation-reason-detail': string;
      commission: string;
      'receiver-annual-accumulated': number;
      'receiver-cellphone': string;
      'receiver-document-number': string;
      'receiver-document-type-id': string;
      'receiver-document-type-name': string;
      'receiver-fullname': string;
      'receiver-monthly-accumulated': number;
      'sender-annual-accumulated': number;
      'sender-cellphone': string;
      'sender-document-number': string;
      'sender-document-type-id': string;
      'sender-document-type-name': string;
      'sender-fullname': string;
      'sender-monthly-accumulated': number;
      'sent-channel': string;
      'sent-correspondent': string;
      'sent-date': string;
      'sent-office': string;
      'status-channel': string;
      'status-correspondent': string;
      'status-date': string;
      'status-id': string;
      'status-name': string;
      'status-office': string;
      taxes: string;
      total: string;
    };
  };
}

export class FakeTransfersRepository implements TransfersRepository {
  dataTransfer: ResultTransferItem = {
    data: {
      type: 'ConsultByReferenceResponse',
      id: '1566',
      attributes: {
        'sender-document-type-id': '1',
        'sender-document-type-name': 'CC',
        'sender-document-number': '99',
        'sender-fullname': 'LUIS CAMILO FORONDA CARDONA',
        'sender-cellphone': '3000000001',
        'sender-monthly-accumulated': 0,
        'sender-annual-accumulated': 0,
        'receiver-document-type-id': '1',
        'receiver-document-type-name': 'CC',
        'receiver-document-number': '88',
        'receiver-fullname': 'JUAN ELKIN PEREZ ROMERO',
        'receiver-cellphone': '3000000002',
        'receiver-monthly-accumulated': 0,
        'receiver-annual-accumulated': 0,
        amount: '18000.12',
        commission: '3600.25',
        taxes: '342',
        total: '21942.38',
        'sent-date': '2019-04-01 15:07:22.848',
        'sent-channel': 'C1',
        'sent-correspondent': 'C2',
        'sent-office': '02',
        'status-id': '2',
        'status-name': 'PAGADO',
        'status-date': '2019-04-20 14:14:06.068',
        'status-channel': 'C1',
        'status-correspondent': 'C1',
        'status-office': '01',
        'cancellation-reason': '1',
        'cancellation-reason-detail': 'test'
      }
    }
  };

  dataTransfers: ResultTransfer = {
    page: 0,
    meta: {
      'total-items': 1,
      'items-page': 10,
      'exist-more-pages': 0,
      'document-type-id': 'FS001',
      'document-type-name': 'Cédula de ciudadanía',
      'document-number': '123',
      fullname: 'Julian Restrepo',
      'montly-accumulated': 0,
      'annual-accumulated': 0
    },
    data: [
      {
        id: '1',
        type: 'Giro',
        attributes: {
          'cancellation-reason': null,
          'cancellation-reason-detail': null,
          'document-number': '1234',
          'document-type-id': 'FS001',
          'document-type-name': 'Cédula de ciudadanía',
          fullname: 'Andres',
          'receiver-cellphone': 31234,
          'sender-cellphone': 32134,
          'sent-transaction-id': '435334',
          amount: '54000',
          commission: '4500',
          taxes: '540.43',
          'sent-date': '2018-04-05',
          'sent-channel': 'CB',
          'sent-correspondent': '123',
          'sent-office': '123',
          'status-id': '1',
          'status-name': 'Disponible_pagar',
          'status-date': '2018-05-05',
          'status-channel': 'CB',
          'status-correspondent': '123',
          'status-office': '43'
        }
      }
    ]
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.dataTransfer);
  }

  getItemId(data: SearchReference): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.dataTransfer);
  }

  getItemSearch(data: SearchCustomer) {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.dataTransfers);
  }

  validateEdit(data: SearchReference) {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  validateCancel(data: SearchReference) {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  validateReverse(data: SearchReference) {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(transfer: TransferEdit) {
    return of(true);
  }

  editId(transfer: TransferEdit) {
    return of(true);
  }

  cancel(data: SearchReference) {
    return of(true);
  }

  reversed(data: SearchReference) {
    return of(true);
  }
}
